"use client"

import { useEffect, useRef } from "react"

import { useRouter } from "next/navigation"

import { useHeldValue } from "@/lib/hooks/use-held-value"
import { useSession } from "@/platform/session/use-session"
import { ANONYMOUS_VIEWER, viewerOf } from "@/platform/session/viewer"

export const useRenderedViewer = (renderedFor: string | undefined, personalize: boolean): { current: boolean; hidden: boolean } => {
  const router = useRouter()
  const tracksViewer = personalize && renderedFor !== undefined
  const { status } = useSession(tracksViewer)
  const live = viewerOf(status)
  const current = useHeldValue(live, live === null)
  const stale = tracksViewer && current !== null && current !== renderedFor
  const refreshedFor = useRef<string | null>(null)

  useEffect(() => {
    if (!stale || refreshedFor.current === current) return
    refreshedFor.current = current
    router.refresh()
  }, [stale, current, router])

  return { current: !tracksViewer || current === renderedFor, hidden: stale && renderedFor !== ANONYMOUS_VIEWER }
}
